var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 3.40039H4.99922",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59999 16.9998C6.58821 16.9998 8.19998 15.388 8.19998 13.3998C8.19998 11.4116 6.58821 9.7998 4.59999 9.7998C2.61177 9.7998 1 11.4116 1 13.3998C1 15.388 2.61177 16.9998 4.59999 16.9998Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 16.9998C18.5882 16.9998 20.2 15.388 20.2 13.3998C20.2 11.4116 18.5882 9.7998 16.6 9.7998C14.6118 9.7998 13 11.4116 13 13.3998C13 15.388 14.6118 16.9998 16.6 16.9998Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28077 1H2.92078C2.30222 1 1.80078 1.50144 1.80078 2.12V5.47999C1.80078 6.09854 2.30222 6.59998 2.92078 6.59998H6.28077C6.89932 6.59998 7.40076 6.09854 7.40076 5.47999V2.12C7.40076 1.50144 6.89932 1 6.28077 1Z",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60799 6.59961H9.62399H7.86399L5 13.1916H9.93598L7.86399 6.59961",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94353 13.1924C9.94353 13.1924 9.61553 7.88043 15.7035 6.44043L14.3035 6.88043L16.5995 13.6964",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8018 4.19922H15.2018C15.2018 4.19922 16.8017 4.67922 15.7058 6.43921",
    stroke: "#81BC45",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.f2a15f1eae134fcefd2bb1572386402c.svg";
export { ForwardRef as ReactComponent };